import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faDisplay } from '@fortawesome/free-solid-svg-icons';

import axiosTenant from '../../../store/utils/tenant';
import { cognitoUri } from '../../../constants/defaultValues';

import Swal from "sweetalert2";
import Loader from '../../../assets/components/loader';

import {
  createInstance,
  callbackInstance,
  getVirtualSpaces,
  getCustomerSubscriptionById,
  getCustomerId,
  getCompanies,
  resetCreateVirtualSpace,
  resetVirtualSpaces,
  notification,

  resetExecutionARN,
  setRedirectStatus,

  getCountries,
  getStates
} from '../../../store/actions';
import { getCustomer } from '../../../utils/helpers';

import { isDevEnv } from '../../../constants/defaultValues';

import CreateVSSkeleton from './createVSSkeleton';

const CreateVirtualSpace = () => {

  const customerId = getCustomer();
  const param = useParams();
  const dispatch = useDispatch();
  const createInfo = useSelector((state) => state.createVirtualSpace);
  const navigate = useNavigate();

  const subscriptionId = param && param.subscriptionId ? param.subscriptionId : null

  const [checkSubscriptions, setCheckSubscriptions] = useState(false)
  const [checkingDomain, setCheckingDomain] = useState(false)
  const [instance, setInstance] = useState({
    instanceName: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    customDomain: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    description: {
      value: "",
      focused: false,
      required: false,
      error: ""
    }
  })
  const [userDomain, setUserDomain] = useState("")
  const [company, setCompany] = useState();

  useEffect(() => {
    if (customerId === "") {
      navigate('/')
    }
  }, [])

  useEffect(() => {
    if (!createInfo.countriesRequested){
      dispatch(getCountries())
    }
  }, [createInfo.countriesRequested])

  useEffect(() => {
    if (!createInfo.instancesRequested && createInfo.userObtained){
      dispatch(getVirtualSpaces(createInfo.user.email));
    }
  }, [createInfo.instancesRequested, createInfo.userObtained])

  useEffect(() => {
    if (createInfo.instancesObtained && createInfo.userObtained) {
      let subscriptionsFound = 0;
      createInfo.virtualSpaces.map((instance) => {
        if (instance.chargebeePurchaseId === subscriptionId){
          subscriptionsFound += 1;
          Swal.fire({
            icon: 'error',
            text: `There is already a virtual space associated with this subscription`,
            confirmButtonText: "Accept",
            showConfirmButton: true,
            showCancelButton: false,
            didOpen() {
              let confirmButtons = document.getElementsByClassName("swal2-confirm")[0]
              confirmButtons.style.backgroundColor = "#611C35";
              confirmButtons.style.boxShadow = "none";
              confirmButtons.style.color = "#ffffff";
              confirmButtons.style.border = "#611C35";
            }
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(resetCreateVirtualSpace());
              dispatch(resetVirtualSpaces());
              navigate('/myVirtualSpaces')
            }
          })
        }
      })
      if (subscriptionsFound === 0){
        setCheckSubscriptions(true);
      }else{
        setCheckSubscriptions(false);
      }
    }
  }, [createInfo.instancesObtained, createInfo.userObtained])

  useEffect(() => {
    if (!createInfo.subscriptionObteined){
      dispatch(getCustomerSubscriptionById(subscriptionId));
    }
  }, [createInfo.subscriptionObteined])

  useEffect(() => {
    if (!createInfo.userRequested){
      dispatch(getCustomerId());
    }
  }, [createInfo.userRequested])

  useEffect(() => {
    if (createInfo.userObtained && !createInfo.statesRequested){
      dispatch(getStates({ isoCode: createInfo.user.billingAddress.country, countryId: "" }));
    }
  }, [createInfo.userObtained])

  useEffect(() => {
    if (!createInfo.companyTypesObtained){
      dispatch(getCompanies());
    }
  }, [createInfo.companyTypesObtained])

  useEffect(() => {
    if (createInfo && createInfo.user && createInfo.user.email){
      const domain = createInfo.user.email.match(/@(.+)/);
      if (domain && domain.length > 1) {
        switch (domain[1]) {
          case 'gmail':
            setUserDomain("");
            break;
          case 'outlook':
            setUserDomain("");
            break;
          case 'hotmail':
            setUserDomain("");
            break;
          case 'yahoo':
            setUserDomain("");
            break;
          default:
            setUserDomain(domain[1]);
        }
      } else {
        setUserDomain("")
      }
    }
  }, [createInfo.user])

  useEffect(() => {
    if (createInfo.companyTypes.lengthc > 0 && createInfo.user.cfIndustry){
      createInfo.companyTypes.map((company) => {
        if (company.name === createInfo.user.cfIndustry){
          setCompany(company.id);
        }
      })
    }
  }, [createInfo.companyTypes])

  const handleInputChange = (ev) => {
    setInstance(prevInstance => ({
      ...prevInstance,
      [ev.target.name]: {
        ...prevInstance[ev.target.name],
        value: ev.target.value,
        focused: true,
        error: prevInstance[ev.target.name].required ? validate(ev.target.name, ev.target.value) : ""
      }
    }))
  }

  const handleOnfocus = (ev) => {
    setInstance(prevInstance => ({
      ...prevInstance,
      [ev.target.name]: {
        ...prevInstance[ev.target.name],
        focused: true,
        error: prevInstance[ev.target.name].required ? validate(ev.target.name, ev.target.value) : ""
      }
    }))
  }

  async function checkInstanceDomain() {
    let value = instance.customDomain.value
    if(value.length > 2){
      try {
        setCheckingDomain(true)
        let response = await axiosTenant.get(`/check-domain?domain=${value}`);
        if (response && response.data && response.data.success && response.data.available) {
          response.data.value = value;
          setCheckingDomain(false)
          setInstance(prevInstance => ({
            ...prevInstance,
            ["customDomain"]: {
              ...prevInstance["customDomain"],
              value: value,
              focused: true,
              error: ""
            }
          }))
          Swal.fire({
            icon: 'warning',
            title: 'Creating Virtual Space',
            html: `This process may take a few minutes.`,
            confirmButtonText: "Ok",
            showConfirmButton: true,
            showCancelButton: true,
            didOpen() {
              let confirmButtons = document.getElementsByClassName("swal2-confirm")[0]
              confirmButtons.style.backgroundColor = "#611C35";
              confirmButtons.style.color = "#ffffff";
              confirmButtons.style.border = "#611C35";
              confirmButtons.style.boxShadow = "none";
              let cancelButton = document.getElementsByClassName("swal2-cancel")[0]
              confirmButtons.style.boxShadow = "none";
              cancelButton.style.backgroundColor = "#ffffff";
              cancelButton.style.color = "#611C35";
              cancelButton.style.border = "1px solid #611C35";
              confirmButtons.style.boxShadow = "none";
            }
          }).then((result) => {
            if (result.isConfirmed) {
              let country = createInfo.countries.filter(country => country.isoCode === createInfo.user.billingAddress.country)
              let state = createInfo.states.filter(state => state.isoCode === createInfo.user.billingAddress.state)
              let data = {
                companyData: {
                  name: createInfo.user.company,
                  address: createInfo.user.cfAddress,
                  domain: userDomain,
                  billingAddress: createInfo.user.billingAddress.line1,
                  companyTypeId: company,
                  country: country.id,
                  state: state,
                  zip: createInfo.user.billingAddress.zip ? createInfo.user.billingAddress.zip : "",
                  phone: createInfo.user.billingAddress.phone,
                  website: createInfo.user.cfWebsite,
                },
                contactData: {
                  firstName: createInfo.user.firstName,
                  lastName: createInfo.user.lastName,
                  phone: createInfo.user.cfDialCountryCode + createInfo.user.cfSinglePhoneNumber,
                  email: createInfo.user.email,
                  hubspotContactId: createInfo.user.cfHubspotContactId,
                  chargebeeCustomerId: createInfo.user.id
                },
                instanceData: {
                  code: instance.customDomain.value,
                  description: instance.description.value,
                  name: instance.instanceName.value,
                  urls: {
                    admin: isDevEnv ? `${instance.customDomain.value}.marquet.dev` : `${instance.customDomain.value}.marquet.app`,
                    events: isDevEnv ? `${instance.customDomain.value}.marquet.dev` : `${instance.customDomain.value}.marquet.events`
                  }
                },
                subscriptionData: {
                  packageId: 3,
                  priceId: 2,
                  startDate: new Date(createInfo.subscription.startedAt * 1000),
                  endDate: null,
                  currency: createInfo.subscription.currencyCode,
                  price: createInfo.subscription.mrr / 100,
                  numberOfMonths: createInfo.subscription.billingPeriodUnit === "month" ? 1 : 12,
                  chargeBeePurchaseId: createInfo.subscription.id,
                  isDemo: true,
                  status: createInfo.subscription.status
                }
              }
              if (data.companyData.zip === "") {
                delete data["companyData"]["zip"]
              }
              dispatch(resetVirtualSpaces());
              dispatch(createInstance(data));
            }
          })
        } else if (response && response.data && response.data.success && !response.data.available) {
          response.data.value = value;
          setCheckingDomain(false)
          setInstance(prevInstance => ({
            ...prevInstance,
            ["customDomain"]: {
              ...prevInstance["customDomain"],
              value: value,
              focused: true,
              error: response.data.message
            }
          }))
        }
      } catch (e) {
        dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
        setCheckingDomain(false)
        console.log("Error:", e)
      }
    }
  }

  const validate = (name, value) => {
    switch (name) {
      case ("instanceName"):
        if (value.length === 0) {
          return "Virtual space name is required"
        } else if (value.length < 3) {
          return "Virtual space name must be longer"
        } else if (value.length > 25) {
          return "Virtual space name must be shorter"
        } else {
          return ""
        }
      case ("customDomain"):
        if (value.length === 0) {
          return "Custom domain is required"
        } else if (value.length < 3) {
          return "Custom domain must be longer"
        } else if (value.length > 25) {
          return "Custom domain must be shorter"
        } else if (!/(^[a-z][a-z0-9-]+$)/.test(value)) {
          return "Only lowercase letters, numbers and hyphens are accepted."
        } else {
          return ""
        }
      default:
        return ""
    }
  }

  function disabledSubmit() {
    if (createInfo.loading){
      return true
    }
    if (checkingDomain){
      return true
    }
    let keys = Object.keys(instance)
    for (let i = 0; i < keys.length; i++) {
      if (instance[keys[i]].required) {
        if (instance[keys[i]].focused && instance[keys[i]].error !== "") {
          return true
        } else if (!instance[keys[i]].focused) {
          return true
        }
      }
    }
    return false
  }

  const createNewInstance = (ev) => {
    ev.preventDefault();
    checkInstanceDomain();
  }

  function trackCreation(executionArn, attempts = 0) {
    const INTERVAL_TIME = 20000;
    const MAX_ATTEMPTS = 20;
    return new Promise(function (resolve, reject) {
      if (executionArn === "") reject({ message: 'No execution in process' })
      const timer = setInterval(async () => {
        if (attempts > MAX_ATTEMPTS) {
          clearInterval(timer);
          reject({ message: 'Import failed: max attempts' });
          dispatch(notification({ title: `We are having some issues`, message: `Import failed: max attempts`, type: `error` }))
          dispatch(resetExecutionARN());
          return;
        }
        try {
          const response = await axiosTenant.get(`/get-process-response?callback=1`, {customHeader: executionArn});
          if (response && response.data && response.data.success){
            if (response.data.success === true){
              dispatch(notification({ title: `Virtual Space Creation`, message: `${response.data.message}`, type: `success` }))
              clearInterval(timer);
              dispatch(resetExecutionARN());
              dispatch(setRedirectStatus());
            }else{
              dispatch(notification({ title: `We are having some issues`, message: `${response.data.message}`, type: `error` }))
              dispatch(resetExecutionARN());
              clearInterval(timer);
            }
          } else if (response && response.data && response.data.status){
            attempts++;
          }
        } catch (error) {
          clearInterval(timer);
          dispatch(notification({ title: `We are having some issues`, message: `${error.message}`, type: `error` }))
          dispatch(resetExecutionARN());
          reject(error);
        }
      }, INTERVAL_TIME);
    });
  }

  useEffect(()=>{
    if (createInfo.executionArn !== "") {
      trackCreation(createInfo.executionArn)
    }
  }, [createInfo.executionArn])

  useEffect(() => {
    if (createInfo.redirect){
      dispatch(resetCreateVirtualSpace());
      navigate('/myVirtualSpaces')
    }
  }, [createInfo.redirect])

  return (
    <>
      <div className="create--instance">
        <div className="instance--description">
          <div>
            Managing multiple events across different stores or departments in your organization can be overwhelming. Marquet makes it easier with virtual spaces.
          </div>
          <div>
            Virtual spaces are event sub - divisions within the same account. They give you the flexibility to manage more complex scenarios within your organization, like sister brands or foreign subsidiaries.
            They will also empower you to:
          </div>
          <div className="description--list">
            <div>
              <FontAwesomeIcon icon={faCheck} style={{ color: "#611C35" }} />
              <p>
                Assign teams to different virtual spaces
              </p>
            </div>
            <div>
              <FontAwesomeIcon icon={faCheck} style={{ color: "#611C35" }} />
              <p>
                Isolate data to promote individial products or categories across independent virtual stores
              </p>
            </div>
            <div>
              <FontAwesomeIcon icon={faCheck} style={{ color: "#611C35" }} />
              <p>
                Preserve autonomy after  a merger and  an acquisition
              </p>
            </div>
            <div>
              <FontAwesomeIcon icon={faCheck} style={{ color: "#611C35" }} />
              <p>
                Manage through one central point of control
              </p>
            </div>
          </div>
        </div>
        {(!createInfo.loadedFirstTime || !checkSubscriptions) &&
          <div className='form--loading'>
            <CreateVSSkeleton />
          </div>
        }
        {createInfo.loadedFirstTime && checkSubscriptions &&
          <div className='create--instance--form'>
            <form className='marquet--form two--columns--form' onSubmit={ev => createNewInstance(ev)}>
              <div className="marquet--form--group">
                <div className={instance.instanceName.focused === true ?
                  instance.instanceName.error === "" ? "input--group input--success" : "input--group input--error" : "input--group"}>
                  <label>
                    VIRTUAL SPACE NAME<b> *</b>
                  </label>
                  <input
                    name="instanceName"
                    type="text"
                    maxLength={30}
                    onChange={ev => handleInputChange(ev)}
                    onFocus={ev => handleOnfocus(ev)}
                    value={instance.instanceName.value} />
                </div>
                <div className="invalid--feedback">{instance.instanceName.error}</div>
              </div>
              <div className="marquet--form--group">
                <div className={instance.customDomain.focused === true ?
                  instance.customDomain.error === "" ? "input--group input--success" : "input--group input--error" : "input--group"}>
                  <label>
                    CUSTOM DOMAIN<b> *</b>
                  </label>
                  <div className="row--form">
                    <span>https://</span>
                    <input
                      name="customDomain"
                      type="text"
                      maxLength={30}
                      style={{ borderBottom: "1px solid #C4C4C4" }}
                      onChange={ev => handleInputChange(ev)}
                      onFocus={ev => handleOnfocus(ev)}
                      value={instance.customDomain.value}
                      disabled={checkingDomain}/>
                    <span>{isDevEnv ? `.marquet.dev` :`.marquet.app`}</span>
                  </div>
                </div>
                {!checkingDomain && <div className="invalid--feedback">{instance.customDomain.error}</div>}
              </div>
              <div className="marquet--form--group form--group--row">
                <div className={instance.description.focused === true ?
                  instance.description.error === "" ? "input--group input--success" : "input--group input--error" : "input--group"}>
                  <label>
                    DESCRIPTION
                  </label>
                  <div>
                    <textarea
                      name="description"
                      type="text"
                      maxLength={150}
                      rows={4}
                      onChange={ev => handleInputChange(ev)}
                      onFocus={ev => handleOnfocus(ev)}
                      value={instance.description.value} />
                  </div>
                </div>
                <div className="invalid--feedback">{instance.description.error}</div>
              </div>
              <div className="marquet--button--group" style={{marginBottom:"0px"}}>
                <button
                  className="custom--button custom--button--marquet"
                  disabled={disabledSubmit()}
                  type='submit'>
                  {checkingDomain === true ?
                    <>
                      Checking domain...
                      {createInfo.loading && <Loader size="xs" />}
                    </>:
                    <>
                      Create Virtual Space
                      {createInfo.loading && <Loader size="xs" />}
                    </>
                  }
                </button>
              </div>
            </form>
          </div>
        }
      </div>
    </>
  )
}

export default CreateVirtualSpace;